<template>
   <div>
       <home></home>
        <div class="pagerc">
            <div class="headerimg">
                <img class="pcshow" src="../assets/images/bm.jpg" alt="">
                <img class="mshow" src="../assets/images/mbm.png" alt="">
                <div class="title">
                <div class="titlep">
                        <h3>报名参会</h3>
                        <h4>REGISTRATION</h4>
                    </div>
                </div>
            </div>
            <div class="inchild clear">
                <div class="wrapleft">
                    <div class="shop">
                        <h2>门票信息</h2>
                        <p>*票价含13-14日午餐及全程茶歇</p>
                        <img style="width:100%;" src="../assets/images/ticket1.png" alt="">
                    </div>
                    <div class="enroll">
                        <h2 class="bot0">报名参会</h2>
                        <iframe height="800" allowTransparency="true" scrolling="no" style="display:block;min-width:100%;width:100px;border:none;overflow:auto;" frameborder="0" src="https://casey0609.mikecrm.com/FP473cZ"></iframe>
                    </div>
                </div>
                <wrapleft></wrapleft>
            </div>
        </div>
        <foots></foots>
   </div>
</template>

<script>
 import home from '@/components/commn/home'
  import foots from '@/components/commn/foots'
  import wrapleft from '@/components/commn/wrapleft'
 export default {
      components:{
        home,
        foots,
        wrapleft
      },
       metaInfo: {
            title: '报名参会-第42届全球人才评鉴高峰会暨领导人才发展论坛',
            meta: [
            {
                name: 'keywords',
                content: '第42届全球人才评鉴高峰会，领导人才发展论坛'
            },
            {
                name: 'description',
                content: '第42届全球人才评鉴高峰会暨领导人才发展论坛全程参会门票支持在线购买。'
            }
            ]
        },
        data () {
            return {

            }
        }
    }
</script>
<style>
    @import url('../assets/css/inpublic.css');
    
    .shop h3 {
        text-align: center;
        font-size: 40px;
        padding: 0 0 10px 0
    }
    .shop p {
        text-align: center !important;
    }
    table td, table th {
        border-width: 1px;
        *border-width: 0 1px 1px 0;
        border-style: solid;
        border-color: #666;
        background-color: #ffffff;
        padding:12px 10px;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 2;
        text-align: center;
    }
    table{
        border-collapse: collapse;
    }
    @media screen and (max-width:768px) {
        .enroll {
            width: 100%;
            margin: 0 auto;
            position: relative;
        }
        .shop {
            padding-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/enroll.vue